import React from "react";
import ReactDOM from "react-dom/client";
import AiDeliveryTeamStructure from "./ai-delivery-team-structure";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AiDeliveryTeamStructure />
  </React.StrictMode>,
);
